import { useEffect, useState } from 'react';
import { connectionTier, subscribeTier, tierWidthCap } from '../network/speed.js';

/**
 * Widest image rung worth requesting on this link, or undefined for no cap.
 * Undefined until mounted so server and first client render agree.
 * @returns {{ cap: number|undefined, tier: 'slow'|'medium'|'fast'|null }}
 */
export function useConnectionTier() {
    const [tier, setTier] = useState(null);
    useEffect(() => {
        setTier(connectionTier());
        return subscribeTier(setTier);
    }, []);
    const limit = tier ? tierWidthCap(tier) : Number.POSITIVE_INFINITY;
    return {
        tier,
        cap: Number.isFinite(limit) ? limit : undefined,
    };
}

export default function useImageCap() {
    return useConnectionTier().cap;
}
